// src/Footer.js
import React from 'react';
import { useLanguage } from './LanguageContext';
import './Footer.css'; // Подключаем стили для футера

// Импортируем логотип и иконки
import footerLogo from './assets/logo-main.png';
import { FaPhoneAlt, FaComments, FaInstagram, FaTelegramPlane, FaWhatsapp } from 'react-icons/fa';
import { SiTiktok } from 'react-icons/si';

const Footer = ({ id }) => {
  const { t } = useLanguage();

  return (
    <footer id={id} className="site-footer">
      <div className="footer-content">
        {/* --- Левая колонка --- */}
        <div className="footer-column">
          <img src={footerLogo} alt="AI-SON" className="footer-logo" />
          <div className="footer-contact-block">
            <p>{t('questionsRemain')}</p>
            <div className="footer-phone">
              <FaPhoneAlt />
              <div>
                <span>{t('callUs')}</span>
                <a href="tel:+77073171819">+7 707 317 18 19</a>
              </div>
            </div>
          </div>
        </div>

        {/* --- Центральная колонка --- */}
        <div className="footer-column">
          <div className="footer-chat-block">
            <p>{t('chatAnswer')}</p>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
<a href="#" className="footer-chat-link">
  <FaComments />
  <span>{t('chat')}</span>
</a>
          </div>
        </div>

        {/* --- Правая колонка --- */}
        <div className="footer-column">
          <p>{t('followSocial')}</p>
          <div className="social-icons">
            <a href="https://www.instagram.com/aison.matras" target="_blank" rel="noopener noreferrer" className="instagram-icon">
              <FaInstagram />
            </a>
            <a href="https://www.tiktok.com/@aison.matras" target="_blank" rel="noopener noreferrer" className="tiktok-icon">
              <SiTiktok />
            </a>
            <a href="https://t.me/aison_kz" target="_blank" rel="noopener noreferrer" className="telegram-icon">
              <FaTelegramPlane />
            </a>
            <a href={`https://wa.me/77073171819?text=${encodeURIComponent(t('whatsappMessage'))}`} target="_blank" rel="noopener noreferrer" className="whatsapp-icon">
              <FaWhatsapp />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;